import React, { useState, useEffect } from "react";
import logo from "./../assets/logo.png";
import "../App.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LogoutIcon from '@mui/icons-material/Logout';
import { logout } from "../pages/Auth/Helper";
function Sidebar() {
  let location = useLocation();
  let navigate = useNavigate();
  let [selectedpanel, setselectedpanel] = useState("dashboard");
  let [drop, setdrop] = useState(0);
  let [toggle, setToggle] = useState(true);
  let [userPermissions, setUserPermissions] = useState([]);
  let [isAdmin, setIsAdmin] = useState(false);
  let [arrow, setarrow] = useState({
    pendingApproval: false,
    user: false,
    flexperts: false,
    job: false,
    cms: false,
    page: false,
    email: false,
    country: false,
    buisness: false,
    faq: false,
    Custom : false,
    resource: false,
    metaData: false,
    payments: false,
    users: false,
  });
  const [active, setActive] = useState({
    pendingApproval: "hidden py-2 space-y-2",
    user: "hidden py-2 space-y-2",
    flexperts: "hidden py-2 space-y-2",
    job: "hidden py-2 space-y-2",
    cms: "hidden py-2 space-y-2",
    page: "hidden py-2 space-y-2",
    email: "hidden py-2 space-y-2",
    country: "hidden py-2 space-y-2",
    buisness: "hidden py-2 space-y-2",
    faq: "hidden py-2 space-y-2",
    Custom : "hidden py-2 space-y-2",
    resource: "hidden py-2 space-y-2",
    metaData: "hidden py-2 space-y-2",
    payments: "hidden py-2 space-y-2",
    users: "hidden py-2 space-y-2",
  });
  const handleChange = (e, name) => {
    e.preventDefault();
    setselectedpanel(name);
    setdrop(0);
    const newActive = {
        pendingApproval: "hidden py-2 space-y-2",
        user: "hidden py-2 space-y-2",
        flexperts: "hidden py-2 space-y-2",
        job: "hidden py-2 space-y-2",
        cms: "hidden py-2 space-y-2",
        page: "hidden py-2 space-y-2",
        email: "hidden py-2 space-y-2",
        country: "hidden py-2 space-y-2",
        buisness: "hidden py-2 space-y-2",
        faq: "hidden py-2 space-y-2",
        Custom: "hidden py-2 space-y-2",
        resource: "hidden py-2 space-y-2",
        metaData: "hidden py-2 space-y-2",
        payments: "hidden py-2 space-y-2",
        users: "hidden py-2 space-y-2",
      };
    if (active[name] === "py-2 space-y-2") {
      newActive[name] = "hidden py-2 space-y-2";
      setarrow({ ...arrow, [name]: false });
    } else {
      newActive[name] = "py-2 space-y-2";
      setarrow({ ...arrow, [name]: true });
    }
    setActive(newActive);
  };
  useEffect(() => {
    console.log("toggled");
  }, [active]);

  useEffect(() => {
    const cmsPermissions = localStorage.getItem('CMSUsersPermission');
    if (cmsPermissions) {
      setUserPermissions(JSON.parse(cmsPermissions));
      setIsAdmin(false);
    } else {
      setUserPermissions([]);
      setIsAdmin(true);
    }
  }, []);

  useEffect(() => {
    if (location.pathname.includes('/ShortenUrl')) {
      setselectedpanel("shortenUrl");
    } else if (location.pathname.includes('/sales-users') || location.pathname.includes('/cms-users')) {
      setselectedpanel("users");
      setActive((prev) => ({ ...prev, users: "py-2 space-y-2" }));
      setarrow((prev) => ({ ...prev, users: true }));
      setdrop(location.pathname.includes('/sales-users') ? 1 : 2);
    }
    if (location.pathname.includes('/Flexperts/requests')) {
      setselectedpanel("flexperts");
      setdrop(2);
      setActive((a) => ({ ...a, flexperts: "py-2 space-y-2" }));
      setarrow((ar) => ({ ...ar, flexperts: true }));
    } else if (location.pathname.includes('/Flexperts')) {
      setselectedpanel("flexperts");
      setdrop(1);
      setActive((a) => ({ ...a, flexperts: "py-2 space-y-2" }));
      setarrow((ar) => ({ ...ar, flexperts: true }));
    }
  }, [location.pathname]);
  return (
    <div class="h-screen " aria-label="Sidebar">
      <div
        class="min-h-screen overflow-y-auto py-4 px-3  sticky left-0"
        style={{ backgroundColor: "#FFFFFF" }}
      >
        <ul class="space-y-4">
          <li>
            <a
              href="/"
              className="flex items-center w-full p-2 text-base font-normal text-gray-900 rounded-lg text-white"
            >
              <img src={logo} className="w-32" alt="Avatar" />
            </a>
          </li>
        </ul>
        <br />
        <ul>
          <li>
            <button
              onClick={(e) => (handleChange(e, "dashboard"), navigate('/Dashboard'))}
              type="button"
              style={{
                backgroundColor:
                  selectedpanel === "dashboard" ? "#2EBAA3" : "",
              }}
              className={`flex items-center w-full p-4 text-base font-normal hover:bg-[#E6FCF7] ${
                selectedpanel === "dashboard"
                  ? "text-white"
                  : "text-gray-400"
                }`}
              aria-controls="dropdown-example"
              data-collapse-toggle="dropdown-example"
            >
              <span
                className="flex-1 ml-3 text-left whitespace-nowrap"
                sidebar-toggle-item
              >
                Dashboard
              </span>
            </button>
          </li>
          {(isAdmin || userPermissions.includes('user-manager')) && (
          <li>
            <button
              onClick={(e) => handleChange(e, "pendingApproval")}
              type="button"
              style={{
                backgroundColor:
                  selectedpanel === "pendingApproval" ? "#2EBAA3" : "",
              }}
              className={`flex items-center w-full p-4 text-base font-normal  hover:bg-[#E6FCF7] ${
                selectedpanel === "pendingApproval"
                  ? "text-white"
                  : "text-gray-400"
              }`}
              aria-controls="dropdown-example"
              data-collapse-toggle="dropdown-example"
            >
              <span
                className="flex-1 ml-3 text-left whitespace-nowrap"
                sidebar-toggle-item
              >
                Pending Approval
              </span>
              {arrow.pendingApproval ? (
                <svg
                  sidebar-toggle-item
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              ) : (
                <svg
                  width="16"
                  className="w-6 h-6"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.1658 4.23431C10.4782 4.54673 10.4782 5.05327 10.1658 5.36569L7.53147 8L10.1658 10.6343C10.4782 10.9467 10.4782 11.4533 10.1658 11.7657C9.85336 12.0781 9.34683 12.0781 9.03441 11.7657L5.83441 8.56569C5.52199 8.25327 5.52199 7.74673 5.83441 7.43431L9.03441 4.23431C9.34683 3.9219 9.85336 3.9219 10.1658 4.23431Z"
                    fill="#9E9EA6"
                  />
                </svg>
              )}
            </button>
            <ul
              id="dropdown-example"
              className={active.pendingApproval}
              style={{ backgroundColor: "#E6FCF7" }}
            >
              <li
                onClick={() => {
                  setdrop(1);
                  setselectedpanel("pendingApproval");
                }}
              >
                <Link
                  to="/PendingApproval/ClientApproval"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "pendingApproval" && drop === 1
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  Client Approval
                </Link>
              </li>
              <li
                onClick={() => {
                  setdrop(2);
                  setselectedpanel("pendingApproval");
                }}
              >
                <Link
                  to="/PendingApproval/JobApproval"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "pendingApproval" && drop === 2
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  Job Approval
                </Link>
              </li>
              <li
                onClick={() => {
                  setdrop(3);
                  setselectedpanel("pendingApproval");
                }}
              >
                <Link
                  to="/PendingApproval/ProjectApproval"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "pendingApproval" && drop === 3
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  Project Approval
                </Link>
              </li>
              <li
                onClick={() => {
                  setdrop(4);
                  setselectedpanel("pendingApproval");
                }}
              >
                <Link
                  to="/PendingApproval/VendorApproval"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "pendingApproval" && drop === 4
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  Vendor Approval
                </Link>
              </li>
               <li
                onClick={() => {
                  setdrop(5);
                  setselectedpanel("pendingApproval");
                }}
              >
                <Link
                  to="/PendingApproval/UnverifiedUser"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "pendingApproval" && drop === 5
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  Unverified Users
                </Link>
              </li>
            </ul>
          </li>
          )}

          {(isAdmin || userPermissions.includes('marketing-manager') || userPermissions.includes('sales-access') || userPermissions.includes('user-manager')) && (
          <li>
            <button
              onClick={(e) => handleChange(e, "user")}
              type="button"
              style={{
                backgroundColor: selectedpanel === "user" ? "#2EBAA3" : "",
              }}
              className={`flex items-center w-full p-4 text-base font-normal  hover:bg-[#E6FCF7] ${
                selectedpanel === "user" ? "text-white" : "text-gray-400"
              }`}
              aria-controls="dropdown-example"
              data-collapse-toggle="dropdown-example"
            >
              <span
                className="flex-1 ml-3 text-left whitespace-nowrap"
                sidebar-toggle-item
              >
                User Manager
              </span>
              {arrow.user ? (
                <svg
                  sidebar-toggle-item
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              ) : (
                <svg
                  width="16"
                  className="w-6 h-6"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.1658 4.23431C10.4782 4.54673 10.4782 5.05327 10.1658 5.36569L7.53147 8L10.1658 10.6343C10.4782 10.9467 10.4782 11.4533 10.1658 11.7657C9.85336 12.0781 9.34683 12.0781 9.03441 11.7657L5.83441 8.56569C5.52199 8.25327 5.52199 7.74673 5.83441 7.43431L9.03441 4.23431C9.34683 3.9219 9.85336 3.9219 10.1658 4.23431Z"
                    fill="#9E9EA6"
                  />
                </svg>
              )}
            </button>
            <ul
              id="dropdown-example"
              className={active.user}
              style={{ backgroundColor: "#E6FCF7" }}
            >
              <li
                onClick={() => {
                  setdrop(1);
                  setselectedpanel("user");
                }}
              >
                <Link
                  to="/UserManager/Client"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "user" && drop === 1
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  List of Clients
                </Link>
              </li>
              <li
                onClick={() => {
                  setdrop(2);
                  setselectedpanel("user");
                }}
              >
                <Link
                  to="/UserManager/Vendor"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "user" && drop === 2
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  List of Vendors
                </Link>
              </li>
              {!userPermissions.includes('sales-access') && (
              <li
                onClick={() => {
                  setdrop(3);
                  setselectedpanel("user");
                }}
              >
                <Link
                  to="/UserManager/Consultant"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "user" && drop === 3
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  List of Consultants
                </Link>
              </li>
              )}
              {(isAdmin || userPermissions.includes('user-manager')) && (
              <li
                onClick={() => {
                  setdrop(5);
                  setselectedpanel("user");
                }}
              >
                <Link
                  to="/UserManager/RequestDelete"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "user" && drop === 5
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  Request For Account Deletion
                </Link>
              </li>
              )}
              {(isAdmin || userPermissions.includes('user-manager')) && (
              <li
                onClick={() => {
                  setdrop(6);
                  setselectedpanel("user");
                }}
              >
                <Link
                  to="/UserManager/DeletedUsers"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "user" && drop === 6
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  List of Deleted Users
                </Link>
              </li>
              )}
            </ul>
          </li>
          )}

          {(isAdmin || userPermissions.includes('user-manager')) && (
          <li>
            <button
              onClick={(e) => handleChange(e, "flexperts")}
              type="button"
              style={{
                backgroundColor: selectedpanel === "flexperts" ? "#2EBAA3" : "",
              }}
              className={`flex items-center w-full p-4 text-base font-normal  hover:bg-[#E6FCF7] ${
                selectedpanel === "flexperts" ? "text-white" : "text-gray-400"
              }`}
              aria-controls="dropdown-example"
              data-collapse-toggle="dropdown-example"
            >
              <span
                className="flex-1 ml-3 text-left whitespace-nowrap"
                sidebar-toggle-item
              >
                Flexperts
              </span>
              {arrow.flexperts ? (
                <svg
                  sidebar-toggle-item
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              ) : (
                <svg
                  width="16"
                  className="w-6 h-6"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.1658 4.23431C10.4782 4.54673 10.4782 5.05327 10.1658 5.36569L7.53147 8L10.1658 10.6343C10.4782 10.9467 10.4782 11.4533 10.1658 11.7657C9.85336 12.0781 9.34683 12.0781 9.03441 11.7657L5.83441 8.56569C5.52199 8.25327 5.52199 7.74673 5.83441 7.43431L9.03441 4.23431C9.34683 3.9219 9.85336 3.9219 10.1658 4.23431Z"
                    fill="#9E9EA6"
                  />
                </svg>
              )}
            </button>
            <ul
              id="dropdown-example"
              className={active.flexperts}
              style={{ backgroundColor: "#E6FCF7" }}
            >
              <li
                onClick={() => {
                  setdrop(1);
                  setselectedpanel("flexperts");
                }}
              >
                <Link
                  to="/Flexperts/list"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "flexperts" && drop === 1
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  List of Flexperts
                </Link>
              </li>
              <li
                onClick={() => {
                  setdrop(2);
                  setselectedpanel("flexperts");
                }}
              >
                <Link
                  to="/Flexperts/requests"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "flexperts" && drop === 2
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  Flexperts requests
                </Link>
              </li>
            </ul>
          </li>
          )}

          {(isAdmin || userPermissions.includes('marketing-manager') || userPermissions.includes('sales-access')) && (
          <li>
          <button
            onClick={(e) => {
              handleChange(e, "resource");
              navigate('/resource-enquiry');
            }}
            type="button"
            style={{
              backgroundColor: selectedpanel === "resource" ? "#2EBAA3" : "",
            }}
            className={`flex items-center w-full p-4 text-base font-normal  hover:bg-[#E6FCF7] ${
              selectedpanel === "resource" ? "text-white" : "text-gray-400"
            }`}
            aria-controls="dropdown-example"
            data-collapse-toggle="dropdown-example"
          >
            <span
              className="flex-1 ml-3 text-left whitespace-nowrap"
              sidebar-toggle-item
            >
              Flexpert Enquiry
            </span>
          </button>
        </li>
          )}

          {(isAdmin || userPermissions.includes('job-manager')) && (
          <li>
            <button
              onClick={(e) => handleChange(e, "job")}
              type="button"
              style={{
                backgroundColor: selectedpanel === "job" ? "#2EBAA3" : "",
              }}
              className={`flex items-center w-full p-4 text-base font-normal  hover:bg-[#E6FCF7] ${
                selectedpanel === "job" ? "text-white" : "text-gray-400"
              }`}
              aria-controls="dropdown-example"
              data-collapse-toggle="dropdown-example"
            >
              <span
                className="flex-1 ml-3 text-left whitespace-nowrap"
                sidebar-toggle-item
              >
                Job Manager
              </span>
              {arrow.job ? (
                <svg
                  sidebar-toggle-item
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              ) : (
                <svg
                  width="16"
                  className="w-6 h-6"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.1658 4.23431C10.4782 4.54673 10.4782 5.05327 10.1658 5.36569L7.53147 8L10.1658 10.6343C10.4782 10.9467 10.4782 11.4533 10.1658 11.7657C9.85336 12.0781 9.34683 12.0781 9.03441 11.7657L5.83441 8.56569C5.52199 8.25327 5.52199 7.74673 5.83441 7.43431L9.03441 4.23431C9.34683 3.9219 9.85336 3.9219 10.1658 4.23431Z"
                    fill="#9E9EA6"
                  />
                </svg>
              )}
            </button>
            <ul
              id="dropdown-example"
              className={active.job}
              style={{ backgroundColor: "#E6FCF7" }}
            >
              {/* Manage Broadcast Jobs / Manage Posted Jobs removed from CMS
              <li
                onClick={() => {
                  setdrop(1);
                  setselectedpanel("job");
                }}
              >
                <Link
                  to="/JobManager/Job"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "job" && drop === 1
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  Manage Broadcast Jobs
                </Link>
              </li>
              <li
                onClick={() => {
                  setdrop(2);
                  setselectedpanel("job");
                }}
              >
                <Link
                  to="/JobManager/JobSub"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "job" && drop === 2
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  Manage Posted Jobs
                </Link>
              </li>
              */}
              <li
                onClick={() => {
                  setdrop(3);
                  setselectedpanel("job");
                }}
              >
                <Link
                  to="/JobManager/OrganicJobs"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "job" && drop === 3
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  Organic Jobs
                </Link>
              </li>
              <li
                onClick={() => {
                  setdrop(4);
                  setselectedpanel("job");
                }}
              >
                <Link
                  to="/JobManager/VendoronlyJobs"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "job" && drop === 4
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  Vendor Exclusive jobs
                </Link>
              </li>
            </ul>
          </li>
          )}

          {(isAdmin || userPermissions.includes('user-manager')) && (
          <li>
            <button
              onClick={(e) => handleChange(e, "Custom")}
              type="button"
              style={{
                backgroundColor: selectedpanel === "Custom" ? "#2EBAA3" : "",
              }}
              className={`flex items-center w-full p-4 text-base font-normal  hover:bg-[#E6FCF7] ${
                selectedpanel === "Custom" ? "text-white" : "text-gray-400"
              }`}
              aria-controls="dropdown-example"
              data-collapse-toggle="dropdown-example"
            >
              <span
                className="flex-1 ml-3 text-left whitespace-nowrap"
                sidebar-toggle-item
              >
                Custom Subscription
              </span>
              {arrow.Custom ? (
                <svg
                  sidebar-toggle-item
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              ) : (
                <svg
                  width="16"
                  className="w-6 h-6"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.1658 4.23431C10.4782 4.54673 10.4782 5.05327 10.1658 5.36569L7.53147 8L10.1658 10.6343C10.4782 10.9467 10.4782 11.4533 10.1658 11.7657C9.85336 12.0781 9.34683 12.0781 9.03441 11.7657L5.83441 8.56569C5.52199 8.25327 5.52199 7.74673 5.83441 7.43431L9.03441 4.23431C9.34683 3.9219 9.85336 3.9219 10.1658 4.23431Z"
                    fill="#9E9EA6"
                  />
                </svg>
              )}
            </button>
            <ul
              id="dropdown-example"
              className={active.Custom}
              style={{ backgroundColor: "#E6FCF7" }}
            > 
               <li
                onClick={() => {
                  setdrop(1);
                  setselectedpanel("Custom");
                }}
              >
                <Link
                  to="/custom-subscription/request"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "Custom" && drop === 1
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  User Requests
                </Link>
              </li>         
              <li
                onClick={() => {
                  setdrop(2);
                  setselectedpanel("Custom");
                }}
              >
                <Link
                  to="/UserManager/CustomPlans"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "Custom" && drop === 2
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  List of Custom Plans
                </Link>
              </li>

              <li
                onClick={() => {
                  setdrop(3);
                  setselectedpanel("Custom");
                }}
              >
                <Link
                  to="/custom-subscription"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "Custom" && drop === 3
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  Create Subscription
                </Link>
              </li>
              <li
                onClick={() => {
                  setdrop(4);
                  setselectedpanel("Custom");
                }}
              >
                <Link
                  to="/UserManager/DefaultPlans"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "Custom" && drop === 4
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  Default Plans
                </Link>
              </li>
              {/* <li onClick={() => { setdrop(5); setselectedpanel("Custom"); }}>
                <Link to="/UserManager/Invoicelist" className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group ${selectedpanel === "Custom" && drop === 5 ? "text-black font-semibold" : "text-gray-400 font-normal"}`}>
                  Invoice List
                </Link>
              </li> */}

            </ul>
          </li>
          )}

          {(isAdmin || userPermissions.includes('billing-manager')) && (
          <li>
            <button
              onClick={(e) => handleChange(e, "payments")}
              type="button"
              style={{
                backgroundColor: selectedpanel === "payments" ? "#2EBAA3" : "",
              }}
              className={`flex items-center w-full p-4 text-base font-normal  hover:bg-[#E6FCF7] ${
                selectedpanel === "payments" ? "text-white" : "text-gray-400"
              }`}
              aria-controls="dropdown-example"
              data-collapse-toggle="dropdown-example"
            >
              <span
                className="flex-1 ml-3 text-left whitespace-nowrap"
                sidebar-toggle-item
              >
                Payments & Invoice
              </span>
              {arrow.payments ? (
                <svg
                  sidebar-toggle-item
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              ) : (
                <svg
                  width="16"
                  className="w-6 h-6"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.1658 4.23431C10.4782 4.54673 10.4782 5.05327 10.1658 5.36569L7.53147 8L10.1658 10.6343C10.4782 10.9467 10.4782 11.4533 10.1658 11.7657C9.85336 12.0781 9.34683 12.0781 9.03441 11.7657L5.83441 8.56569C5.52199 8.25327 5.52199 7.74673 5.83441 7.43431L9.03441 4.23431C9.34683 3.9219 9.85336 3.9219 10.1658 4.23431Z"
                    fill="#9E9EA6"
                  />
                </svg>
              )}
            </button>
            <ul
              id="dropdown-example"
              className={active.payments}
              style={{ backgroundColor: "#E6FCF7" }}
            >
              <li
                onClick={() => {
                  setdrop(1);
                  setselectedpanel("payments");
                }}
              >
                <Link
                  to="/PaymentsAndInvoices/Overall"
                  className={`flex items-center p-2 pl-11 w-full text-base rounded-lg transition duration-75 group  
                    ${selectedpanel === "payments" && drop === 1
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  Overall
                </Link>
              </li>

              <li
                onClick={() => {
                  setdrop(2);
                  setselectedpanel("payments");
                }}
              >
                <Link
                  to="/PaymentsAndInvoices/CreateInvoice"
                  className={`flex items-center p-2 pl-11 w-full text-base rounded-lg transition duration-75 group  
                    ${selectedpanel === "payments" && drop === 2
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  Create Invoice
                </Link>
              </li>

              <li
                onClick={() => {
                  setdrop(3);
                  setselectedpanel("payments");
                }}
              >
                <Link
                  to="/PaymentsAndInvoices/ExternalPayments"
                  className={`flex items-center p-2 pl-11 w-full text-base rounded-lg transition duration-75 group  
                    ${selectedpanel === "payments" && drop === 3
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  External Payments
                </Link>
              </li>

              <li
                onClick={() => {
                  setdrop(4);
                  setselectedpanel("payments");
                }}
              >
                <Link
                  to="/PaymentsAndInvoices/PlatformPayments"
                  className={`flex items-center p-2 pl-11 w-full text-base rounded-lg transition duration-75 group  
                    ${selectedpanel === "payments" && drop === 4
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  Platform Payments
                </Link>
              </li>
              <li
                onClick={() => {
                  setdrop(5);
                  setselectedpanel("payments");
                }}
              >
                <Link
                  to="/PaymentsAndInvoices/Proforma"
                  className={`flex items-center p-2 pl-11 w-full text-base rounded-lg transition duration-75 group  
                    ${selectedpanel === "payments" && drop === 5
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  Proforma Invoice
                </Link>
              </li>
            </ul>
          </li>
          )}

          {(isAdmin || userPermissions.includes('user-manager')) && (
          <li>
            <button
              onClick={(e) => handleChange(e, "metaData")}
              type="button"
              style={{
                backgroundColor: selectedpanel === "metaData" ? "#2EBAA3" : "",
              }}
              className={`flex items-center w-full p-4 text-base font-normal  hover:bg-[#E6FCF7] ${
                selectedpanel === "metaData" ? "text-white" : "text-gray-400"
              }`}
              aria-controls="dropdown-example"
              data-collapse-toggle="dropdown-example"
            >
              <span
                className="flex-1 ml-3 text-left whitespace-nowrap"
                sidebar-toggle-item
              >
                Meta Data
              </span>
              {arrow.metaData ? (
                <svg
                  sidebar-toggle-item
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              ) : (
                <svg
                  width="16"
                  className="w-6 h-6"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.1658 4.23431C10.4782 4.54673 10.4782 5.05327 10.1658 5.36569L7.53147 8L10.1658 10.6343C10.4782 10.9467 10.4782 11.4533 10.1658 11.7657C9.85336 12.0781 9.34683 12.0781 9.03441 11.7657L5.83441 8.56569C5.52199 8.25327 5.52199 7.74673 5.83441 7.43431L9.03441 4.23431C9.34683 3.9219 9.85336 3.9219 10.1658 4.23431Z"
                    fill="#9E9EA6"
                  />
                </svg>
              )}
            </button>
            <ul
              id="dropdown-example"
              className={active.metaData}
              style={{ backgroundColor: "#E6FCF7", paddingTop: 0 }}
            >
          <li>
            <button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                const newActive = { ...active };
                const newArrow = { ...arrow };
                
                if (active.email === "py-2 space-y-2") {
                  newActive.email = "hidden py-2 space-y-2";
                  newArrow.email = false;
                } else {
                  newActive.email = "py-2 space-y-2";
                  newArrow.email = true;
                }
                
                setActive(newActive);
                setarrow(newArrow);
              }}
              type="button"
              style={{
                backgroundColor: selectedpanel === "email" ? "#D1FAE5" : "", paddingTop: 12 
              }}
              className={`flex items-center w-full p-2 pl-11 text-base font-normal hover:bg-[#E6FCF7] ${
                selectedpanel === "email" ? "text-black font-semibold" : "text-gray-400"
              }`}
            >
              <span className="flex-1 text-left whitespace-nowrap">
                Email Templates
              </span>
              {arrow.email ? (
                <svg
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              ) : (
                <svg
                  width="16"
                  className="w-6 h-6"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.1658 4.23431C10.4782 4.54673 10.4782 5.05327 10.1658 5.36569L7.53147 8L10.1658 10.6343C10.4782 10.9467 10.4782 11.4533 10.1658 11.7657C9.85336 12.0781 9.34683 12.0781 9.03441 11.7657L5.83441 8.56569C5.52199 8.25327 5.52199 7.74673 5.83441 7.43431L9.03441 4.23431C9.34683 3.9219 9.85336 3.9219 10.1658 4.23431Z"
                    fill="#9E9EA6"
                  />
                </svg>
              )}
            </button>
            <ul
              className={active.email}
              style={{ backgroundColor: "#F0FDF4" }} 
            >
              <li
            onClick={(e) => {
              e.stopPropagation();
              setdrop(11);
              setselectedpanel("metaData");
            }}
          >
            <Link
              to="/EmailTemplates/Templates"
              className={`flex items-center p-2 pl-14 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "metaData" && drop === 11
                  ? "text-black font-semibold"
                  : "text-gray-400 font-normal"
                }`}
            >
              - List of Templates
            </Link>
          </li>

              <li
            onClick={(e) => {
              e.stopPropagation();
              setdrop(12);
              setselectedpanel("metaData");
            }}
          >
            <Link
              to="/EmailTemplates/Templates/DesignList"
              className={`flex items-center p-2 pl-14 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "metaData" && drop === 12
                  ? "text-black font-semibold"
                  : "text-gray-400 font-normal"
                }`}
            >
            - Template Design List
            </Link>
          </li>
            </ul>
          </li>

              {/* Business Type */}
              <li
                onClick={(e) => {
              e.stopPropagation();
              setdrop(1);
              setselectedpanel("metaData");
              navigate("/BusinessType");
            }}
              >
                <Link
                  to="/BusinessType"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "metaData" && drop === 1
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  Business Type
                </Link>
              </li>

              {/* Job Category */}
              <li
              onClick={(e) => {
              e.stopPropagation();
              setdrop(2);
              setselectedpanel("metaData");
              navigate("/JobCategory");
            }}
              >
                <Link
                  to="/JobCategory"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "metaData" && drop === 2
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  Job Category
                </Link>
              </li>

              {/* FAQ Manager */}
              <li
                onClick={(e) => {
              e.stopPropagation();
              setdrop(3);
              setselectedpanel("metaData");
              navigate("/FAQ");
            }}
              >
                <Link
                  to="/FAQ"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "metaData" && drop === 3
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  FAQ Manager
                </Link>
              </li>

              {/* Generate Investor URL */}
              <li
                onClick={(e) => {
              e.stopPropagation();
              setdrop(4);
              setselectedpanel("metaData");
              navigate("/GenerateInvestorUrl");
            }}
              >
                <Link
                  to="/GenerateInvestorUrl"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "metaData" && drop === 4
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  Generate Investor URL
                </Link>
              </li>
            </ul>
          </li>
          )}

          {(isAdmin || userPermissions.includes('user-manager')) && (
          <li>
            <button
              onClick={(e) => {
                handleChange(e, "shortenUrl");
                navigate('/ShortenUrl');
              }}
              type="button"
              style={{
                backgroundColor: selectedpanel === "shortenUrl" ? "#2EBAA3" : "",
              }}
              className={`flex items-center w-full p-4 text-base font-normal  hover:bg-[#E6FCF7] ${
                selectedpanel === "shortenUrl" ? "text-white" : "text-gray-400"
              }`}
              aria-controls="dropdown-example"
              data-collapse-toggle="dropdown-example"
            >
              <span
                className="flex-1 ml-3 text-left whitespace-nowrap"
                sidebar-toggle-item
              >
                Shorten URL
              </span>
            </button>
          </li>
          )}

          {isAdmin && (
          <li>
            <button
              onClick={(e) => handleChange(e, "users")}
              type="button"
              style={{
                backgroundColor: selectedpanel === "users" ? "#2EBAA3" : "",
              }}
              className={`flex items-center w-full p-4 text-base font-normal  hover:bg-[#E6FCF7] ${
                selectedpanel === "users" ? "text-white" : "text-gray-400"
              }`}
              aria-controls="dropdown-users"
              data-collapse-toggle="dropdown-users"
            >
              <span
                className="flex-1 ml-3 text-left whitespace-nowrap"
                sidebar-toggle-item
              >
                Team Manager
              </span>
              {arrow.users ? (
                <svg
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              ) : (
                <svg
                  width="16"
                  className="w-6 h-6"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.1658 4.23431C10.4782 4.54673 10.4782 5.05327 10.1658 5.36569L7.53147 8L10.1658 10.6343C10.4782 10.9467 10.4782 11.4533 10.1658 11.7657C9.85336 12.0781 9.34683 12.0781 9.03441 11.7657L5.83441 8.56569C5.52199 8.25327 5.52199 7.74673 5.83441 7.43431L9.03441 4.23431C9.34683 3.9219 9.85336 3.9219 10.1658 4.23431Z"
                    fill="currentColor"
                  />
                </svg>
              )}
            </button>
            <ul
              className={active.users}
              style={{ backgroundColor: "#F0FDF4" }}
            >
              <li
                onClick={(e) => {
                  e.stopPropagation();
                  setdrop(1);
                  setselectedpanel("users");
                  navigate("/sales-users");
                }}
              >
                <Link
                  to="/sales-users"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "users" && drop === 1
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  Sales Users
                </Link>
              </li>
              <li
                onClick={(e) => {
                  e.stopPropagation();
                  setdrop(2);
                  setselectedpanel("users");
                  navigate("/cms-users");
                }}
              >
                <Link
                  to="/cms-users"
                  className={`flex items-center p-2 pl-11 w-full text-base text-gray-900 rounded-lg transition duration-75 group  ${selectedpanel === "users" && drop === 2
                      ? "text-black font-semibold"
                      : "text-gray-400 font-normal"
                    }`}
                >
                  CMS Users
                </Link>
              </li>
            </ul>
          </li>
          )}

          <li>
            <button
              onClick={(e) => {
                logout()
                navigate("/Login")
              }}
              type="button"
              className={`flex items-center w-full p-4 text-base font-normal text-white  hover:bg-[#E6FCF7]`}
              aria-controls="dropdown-example"
              data-collapse-toggle="dropdown-example"
            >
              <span
                className="flex-1 ml-3 text-left whitespace-nowrap text-gray-400"
                sidebar-toggle-item
              >
                Logout
              </span>
              <span
                className="flex-1 ml-3 text-right whitespace-nowrap text-gray-400"
                sidebar-toggle-item
              >
                <LogoutIcon />
              </span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Sidebar;
